import React from 'react';
import { IconMenu2, IconArrowLeft, IconUsersGroup } from '@tabler/icons-react';
import { ModeSwitch, ChatMode } from './ModeSwitch';
interface TopButtonsProps {
  onMenuClick: () => void;
  onFamilyClick: () => void;
  showBackButton?: boolean;
  onBackClick?: () => void;
  backLabel?: string;
  hideRightButton?: boolean;
  pageTitle?: string;
  chatMode?: ChatMode;
  onModeChange?: (mode: ChatMode) => void;
  hasMessages?: boolean;
}
const modes: ChatMode[] = ['ascolto', 'informazioni', 'attivita'];
const modeLabels: Record<ChatMode, string> = {
  ascolto: 'Ascolto',
  informazioni: 'Info',
  attivita: 'Attività'
};
export function TopButtons({
  onMenuClick,
  onFamilyClick,
  showBackButton = false,
  onBackClick,
  backLabel,
  hideRightButton = false,
  pageTitle = 'Chat',
  chatMode,
  onModeChange,
  hasMessages = false
}: TopButtonsProps) {
  return <div className="px-4 pt-4 pb-3 border-b border-yeppy-text/5 shadow-[0_2px_10px_rgba(29,42,54,0.02)] bg-yeppy-bg/80 backdrop-blur-md sticky top-0 z-20" data-id="element-373">
      <div className="flex items-center gap-3" data-id="element-374">
        {/* Left: Menu or Back Button */}
        {showBackButton ? <button onClick={onBackClick} className="flex items-center justify-center w-10 h-10 bg-white border border-yeppy-text border-opacity-10 rounded-full transition-colors" aria-label="Torna indietro" data-id="element-375">
            <IconArrowLeft className="w-5 h-5 text-yeppy-text" stroke={1.5} data-id="element-376" />
          </button> : <button onClick={onMenuClick} className="flex items-center justify-center w-10 h-10 bg-white border border-yeppy-text border-opacity-10 rounded-full transition-colors" aria-label="Apri menu" data-id="element-377">
            <IconMenu2 className="w-5 h-5 text-yeppy-text" stroke={1.5} data-id="element-378" />
          </button>}

        {/* Center: Page Title */}
        <div className="flex-1 flex justify-center" data-id="element-379">
          <span className="font-rubik text-yeppy-text font-[500] text-[16px]" data-id="element-380">
            {chatMode ? hasMessages ? 'Chat' : 'Chat' : pageTitle}
          </span>
        </div>

        {/* Right: Family Icon Button (or empty space to balance flex) */}
        {hideRightButton ? <div className="w-10 h-10 flex-shrink-0" data-id="element-381" /> : <button onClick={onFamilyClick} className="flex items-center justify-center w-10 h-10 bg-white border border-yeppy-text border-opacity-15 rounded-full transition-colors flex-shrink-0" aria-label="Famiglia" data-id="element-382">
            <IconUsersGroup className="w-5 h-5 text-yeppy-text" stroke={1.5} data-id="element-383" />
          </button>}
      </div>
    </div>;
}